import { FunctionComponent, useMemo } from "react";
import HiveContext, { HiveContextValue } from "contexts/HiveContext";
import useHiveBalanceInTokens from "hooks/useHiveBalanceInTokens";
import useAssets from "hooks/useAssets";

const HiveProvider: FunctionComponent = ({ children }) => {
  const { v2sInWallet } = useAssets();

  const [hiveBalanceInTokens, hiveBalanceInTokensSum, readHiveBalanceInTokens] =
    useHiveBalanceInTokens(v2sInWallet);

  const contextValue = useMemo<HiveContextValue>(
    () => ({
      hiveBalanceInTokens,
      hiveBalanceInTokensSum,
      readHiveBalanceInTokens,
    }),
    [hiveBalanceInTokens, hiveBalanceInTokensSum, readHiveBalanceInTokens]
  );

  return (
    <HiveContext.Provider value={contextValue}>{children}</HiveContext.Provider>
  );
};

export default HiveProvider;
